import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static values = {
        id: String,
    };
    
    initialize() {
        // Cache selectors for better performance
        this.focusableElements = [...this.element.querySelectorAll('a, button')];
        // Pre-check localStorage to avoid layout thrashing
        this.shouldShow = !localStorage.getItem("popup") || localStorage.getItem("popup") !== this.idValue;
    }
    
    connect() {
        // Immediate execution since this is a critical UI element
        if (this.shouldShow) {
            this.open();
        } else {
            this.close();
        }
    }

    open() {
        this.element.classList.add("is-open");
        this.updateTabIndexes(10);
    }

    close() {
        this.element.classList.remove("is-open");
        localStorage.setItem("popup", this.idValue);
        this.updateTabIndexes(-1);
    }

    updateTabIndexes(value) {
        // Use cached elements instead of querying DOM again
        this.focusableElements.forEach(el => {
            el.setAttribute("tabindex", value);
        });
    }
}
